import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

/**
 * Tiny weekly-score trend sparkline. No axes, no tooltip — just the line.
 * Props:
 *  - data: [{week:'2026-W22', score: 64}, ...]
 *  - color: hex (default emerald-600)
 *  - height: px (default 28)
 */
export default function Sparkline({ data, color = "#059669", height = 28 }) {
  if (!data || data.length < 2) {
    return (
      <div
        className="text-[10px] font-mono-data uppercase tracking-widest text-muted-foreground"
        data-testid="sparkline-empty"
      >
        — not enough history yet
      </div>
    );
  }
  // Domain padding: ±5 around min/max, clamped to [0, 100].
  const scores = data.map((d) => d.score);
  const lo = Math.max(0, Math.min(...scores) - 5);
  const hi = Math.min(100, Math.max(...scores) + 5);
  return (
    <div style={{ height }} data-testid="sparkline-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, right: 0, bottom: 2, left: 0 }}>
          <YAxis hide domain={[lo, hi]} />
          <Line
            type="monotone"
            dataKey="score"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
